export class Continent {

    constructor(readonly name: string) {
    }
}



// WEBPACK FOOTER //
// ./src/api/request/Continent.ts